import {
  ADD_TO_FAVORITES,
  REMOVE_FROM_FAVORITES,
  RECEIVE_FAVORITES_OTHER
} from '../actions/FavoritesActions';


const processFavoritesOther = items => {
  return items.map(item => {

    // unwrap the array
    if (item.product_album.length) {
      item.product_album = item.product_album[0];
    }

    return item;
  });
};

export function FavoritesOtherReducer(state = { items: [] }, action) {
  switch (action.type) {
    case ADD_TO_FAVORITES: {
      return {
        isFetching: true,
        didInvalidate: false,
        items: [...state.items, action.item]
      }
    }
    case REMOVE_FROM_FAVORITES: {
      return {
        isFetching: true,
        didInvalidate: false,
        items: state.items.filter( (item) => item.id !== action.item)
      }
    }
    case RECEIVE_FAVORITES_OTHER: {
      const items = processFavoritesOther(action.items);
      const uname = action.uname;

      return {
        isFetching: false,
        didInvalidate: false,
        items: [...state.items, ...items],
        uname:uname
      }
    }
    default: {
      return state;
    }
  }
}


// WEBPACK FOOTER //
// ./src/reducers/FavoritesOtherReducer.js